import React from 'react'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useIsMobile } from '../hooks/useScreenSize'
import logo from '../assets/images/acpg-logo-light-text.png'
import ActionButton from '../components/Button/Button'
import Footer from '../components/Footer/Footer'
import { Image, GridFormContainer, GridItemForm, GridItemImage, GridPageContainer, PageWrapper } from './NotFoundPage.styled'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()
  const isMobile = useIsMobile()

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <PageWrapper>
      <GridPageContainer container spacing={isMobile ? 2 : 4} direction="column">
        <GridItemImage size={{ mobile: 12 }} sx={{ textAlign: 'center' }}>
          <Image src={logo} alt="ACPG Logo" />
        </GridItemImage>

        <GridFormContainer size={{ mobile: 12 }}>
          <GridItemForm size={{ mobile: 12 }}>
            <Typography variant="h1" mb={2}>
              404
            </Typography>
            <Typography variant="body1" mb={3}>
              This page doesn’t exist. Please check the URL or go back home.
            </Typography>
            <ActionButton buttonType="primary" onClick={handleGoHome} size="fullWidth">
              Go to Home
            </ActionButton>
          </GridItemForm>
        </GridFormContainer>
      </GridPageContainer>
      <Footer sx={{ position: 'fixed', bottom: 0, width: '100%' }} />
    </PageWrapper>
  )
}

export default NotFoundPage
